import React from 'react';

import {ReactComponent as burgerMenu} from './burgerMenu.svg';
import {ReactComponent as info} from './info.svg';
import {ReactComponent as calendar} from './calendar.svg';
import {ReactComponent as check} from './check.svg';
import {ReactComponent as close} from './close.svg';
import {ReactComponent as profile} from './profile.svg';
import {ReactComponent as profileVisImp} from './profileVisImp.svg';
import {ReactComponent as eye} from './eye.svg';
import {ReactComponent as eyeOff} from './eyeOff.svg';
import {ReactComponent as eyeFat} from './eyeFat.svg';
import {ReactComponent as eyeOffFat} from './eyeOffFat.svg';
import {ReactComponent as eraseKey} from './eraseKey_v01.svg';
import {ReactComponent as cards} from './cards.svg';
import {ReactComponent as checkRound} from './checkRound.svg';
import {ReactComponent as notCheckRound} from './notCheckRound.svg';
import {ReactComponent as chevronRight} from './chevronRight.svg';
import {ReactComponent as chevronRightThick} from './chevronRightThick.svg';
import {ReactComponent as help} from './help.svg';
import {ReactComponent as helpQuestion} from './helpQuestion.svg';
import {ReactComponent as list} from './list-with-bullets.svg';
import {ReactComponent as mapPoint} from './mapPoint.svg';
import {ReactComponent as lock} from './lock.svg';
import {ReactComponent as signOut} from './signout_v01.svg';
import {ReactComponent as question} from './question.svg';
import {ReactComponent as qrCode} from './qrCode3.svg';
import {ReactComponent as right} from './right.svg';
import {ReactComponent as left} from './left.svg';
import {ReactComponent as noInternet} from './noInternet.svg';
import {ReactComponent as burger} from './burger.svg';
import {ReactComponent as transport} from './services/transport.svg';
import {ReactComponent as banking} from './services/banking.svg';
import {ReactComponent as privileges} from './services/privileges.svg';
import {ReactComponent as volunteers} from './services/volunteers.svg';
import {ReactComponent as loyalty} from './services/loyalty.svg';
import {ReactComponent as socialSupport} from './services/socialSupport.svg';
import {ReactComponent as checkMark} from './check-mark.svg';
import {ReactComponent as checkOn} from './checkOn.svg';
import {ReactComponent as checkOff} from './checkOff.svg';
import {ReactComponent as checkInter} from './checkInter.svg';
import {ReactComponent as Pencil} from './pencil.svg';
import {ReactComponent as phone} from './phone_v01.svg';
import {ReactComponent as email} from './email.svg';
import {ReactComponent as globe} from './globe.svg';
import {ReactComponent as refresh} from './refresh.svg';
import {ReactComponent as Clock} from './clock.svg';
import {ReactComponent as up} from './upThin_v01.svg';
import {ReactComponent as chevronLeft} from './chevron-left.svg';
import {ReactComponent as PhoneFill} from './phoneFill.svg';
import {ReactComponent as plus} from './plus.svg';
import {ReactComponent as plusInCircle} from './plusInCircle.svg';
import {ReactComponent as Clip} from './clip.svg';
import {ReactComponent as Exclamation} from './exclamation.svg';
import {ReactComponent as checkInCircle} from './checkInCircle.svg';
import {ReactComponent as questionInTriangle} from './questionInTriangle.svg';
import {ReactComponent as Filter} from './filter.svg';
import {ReactComponent as Fingerprint} from './fingerprint.svg';
import {ReactComponent as Search} from './search.svg';
import {ReactComponent as chevronDown} from './chevronDown.svg';
import {ReactComponent as chevronUp} from './chevronUp.svg';
import {ReactComponent as chevronUpDropdown} from './chevron-up-dropdown.svg';

import {ReactComponent as userOutlined24} from './userOutlined24.svg';
import {ReactComponent as userOutlined36} from './userOutlined36.svg';
import {ReactComponent as userOutlined100} from './userOutlined100.svg';
import {ReactComponent as userOutlined160} from './userOutlined160.svg';

import {ReactComponent as Clock2} from './clock2.svg';
import {ReactComponent as Location} from './location.svg';
import {ReactComponent as MapMarker} from './map-marker.svg';
import {ReactComponent as MapMarkerV1} from './map-marker_v1.svg';

import {ReactComponent as SocialVk} from './socials/vk.svg';
import {ReactComponent as SocialFacebook} from './socials/facebook.svg';
import {ReactComponent as SocialInstagram} from './socials/instagram.svg';
import {ReactComponent as SocialOk} from './socials/ok.svg';
import {ReactComponent as SocialTelegram} from './socials/telegram.svg';

import {ReactComponent as arrowDown} from './arrowDown.svg';
import {ReactComponent as arrowDownWide} from './arrowDownWide.svg';
import {ReactComponent as arrowUp} from './arrowUp.svg';

import {ReactComponent as TabBarCircle} from './tabbar/tabbar-circle.svg';
import {ReactComponent as TabBarCircleRight} from './tabbar/tabbar-circle-right.svg';
import {ReactComponent as TabBarCard} from './tabbar/tabbar-card.svg';

import {ReactComponent as TabBarHome} from './tabbar/tabbar-home.svg';
import {ReactComponent as TabBarMenu} from './tabbar/tabbar-menu.svg';
import {ReactComponent as TabBarSupport} from './tabbar/tabbar-support.svg';
import {ReactComponent as TabBarPossibilities} from './tabbar/tabbar-possibilities.svg';

import {ReactComponent as Loader1} from './loader/1.svg';
import {ReactComponent as Loader2} from './loader/2.svg';
import {ReactComponent as Loader3} from './loader/3.svg';
import {ReactComponent as Loader4} from './loader/4.svg';
import {ReactComponent as Loader5} from './loader/5.svg';
import {ReactComponent as Loader6} from './loader/6.svg';
import {ReactComponent as Loader7} from './loader/7.svg';

import {ReactComponent as Deer} from './deer.svg';
import {ReactComponent as Land} from './land.svg';
import {ReactComponent as NorthSlogan} from './northSlogan.svg';
import {ReactComponent as ProfileCardDeer} from './cardDeer.svg';

import {ReactComponent as DobroRuLogo} from './dobroruLogo.svg';

import {SvgHoc} from '../../shared/components/svg';
import {IconProps} from '../../shared/components/svg/model';

export type IconSvg = React.FC<IconProps>;

export const images = {
  BurgerMenu: SvgHoc(burgerMenu),
  Info: SvgHoc(info),
  Profile: SvgHoc(profile),
  ProfileVisImp: SvgHoc(profileVisImp),
  Deer: SvgHoc(Deer),
  Land: SvgHoc(Land),
  Eye: SvgHoc(eye),
  EyeFat: SvgHoc(eyeFat),
  EyeOff: SvgHoc(eyeOff),
  EyeOffFat: SvgHoc(eyeOffFat),
  EraseKey: SvgHoc(eraseKey),
  Cards: SvgHoc(cards),
  ChevronRight: SvgHoc(chevronRight),
  ChevronRightThick: SvgHoc(chevronRightThick),
  Help: SvgHoc(help),
  HelpQuestion: SvgHoc(helpQuestion),
  List: SvgHoc(list),
  MapPoint: SvgHoc(mapPoint),
  Lock: SvgHoc(lock),
  SignOut: SvgHoc(signOut),
  Question: SvgHoc(question),
  QrCode: SvgHoc(qrCode),
  Transport: SvgHoc(transport),
  Banking: SvgHoc(banking),
  Privileges: SvgHoc(privileges),
  Volunteering: SvgHoc(volunteers),
  Loyalty: SvgHoc(loyalty),
  SocialSupport: SvgHoc(socialSupport),
  Right: SvgHoc(right),
  Left: SvgHoc(left),
  NoInternet: SvgHoc(noInternet),
  Burger: SvgHoc(burger),
  Check: SvgHoc(check),
  Close: SvgHoc(close),
  Phone: SvgHoc(phone),
  Email: SvgHoc(email),
  CheckMark: SvgHoc(checkMark),
  checkOn: SvgHoc(checkOn),
  checkOff: SvgHoc(checkOff),
  checkInter: SvgHoc(checkInter),
  Pencil: SvgHoc(Pencil),
  Globe: SvgHoc(globe),
  Refresh: SvgHoc(refresh),
  NotCheckRound: SvgHoc(notCheckRound),
  CheckRound: SvgHoc(checkRound),
  Clock: SvgHoc(Clock),
  Clock2: SvgHoc(Clock2),
  Location: SvgHoc(Location),
  MapMarker: SvgHoc(MapMarker),
  MapMarkerV1: SvgHoc(MapMarkerV1),
  Up: SvgHoc(up),
  ArrowDown: SvgHoc(arrowDown),
  ArrowDownWide: SvgHoc(arrowDownWide),
  ArrowUp: SvgHoc(arrowUp),
  ChevronLeft: SvgHoc(chevronLeft),
  PhoneFill: SvgHoc(PhoneFill),
  Plus: SvgHoc(plus),
  PlusInCircle: SvgHoc(plusInCircle),
  Clip: SvgHoc(Clip),
  Exclamation: SvgHoc(Exclamation),
  CheckInCircle: SvgHoc(checkInCircle),
  QuestionInTriangle: SvgHoc(questionInTriangle),
  Search: SvgHoc(Search),
  SocialVk: SvgHoc(SocialVk),
  SocialFacebook: SvgHoc(SocialFacebook),
  SocialInstagram: SvgHoc(SocialInstagram),
  SocialOk: SvgHoc(SocialOk),
  SocialTelegram: SvgHoc(SocialTelegram),
  TabBarPossibilities: SvgHoc(TabBarPossibilities),
  TabBarCircle: SvgHoc(TabBarCircle),
  TabBarCircleRight: SvgHoc(TabBarCircleRight),
  TabBarHome: SvgHoc(TabBarHome),
  TabBarCard: SvgHoc(TabBarCard),
  TabBarMenu: SvgHoc(TabBarMenu),
  TabBarSupport: SvgHoc(TabBarSupport),
  Filter: SvgHoc(Filter),
  Fingerprint: SvgHoc(Fingerprint),
  Calendar: SvgHoc(calendar),
  ChevronDown: SvgHoc(chevronDown),
  ChevronUp: SvgHoc(chevronUp),
  ChevronUpDropdown: SvgHoc(chevronUpDropdown),
  UserOutlined24: SvgHoc(userOutlined24),
  UserOutlined36: SvgHoc(userOutlined36),
  UserOutlined100: SvgHoc(userOutlined100),
  UserOutlined160: SvgHoc(userOutlined160),
  Loader: [
    SvgHoc(Loader1),
    SvgHoc(Loader2),
    SvgHoc(Loader3),
    SvgHoc(Loader4),
    SvgHoc(Loader5),
    SvgHoc(Loader6),
    SvgHoc(Loader7),
  ],
  NorthSlogan: SvgHoc(NorthSlogan),
  ProfileCardDeer: SvgHoc(ProfileCardDeer),
  DobroRuLogo: SvgHoc(DobroRuLogo),
};
